module.exports = __webpack_public_path__ + "media/images/icons/arrow-link-f58a5acb142c32c9792529db29b07840.svg";